import { render, staticRenderFns } from "./table_body.vue?vue&type=template&id=6fab7389&scoped=true&lang=pug"
import script from "./table_body.vue?vue&type=script&lang=js"
export * from "./table_body.vue?vue&type=script&lang=js"
import style0 from "./table_body.vue.css?vue&type=style&index=0&id=6fab7389&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fab7389",
  null
  
)

export default component.exports